import { create } from "zustand";
import axios from "axios";

const seasonStore = create((set) => ({
    season: null,

    seasonForm: {
        seasonNumber: "",
        seriesId: "",
        numberOfEpisodes: "",
        releaseDate: "",
    },

    fetchSeason: async () => {
        // Fetch the seasons
        const res = await axios.get("/season");

        // Set to state
        set({ season: res.data.seasons });
    },

    getSeasonsBySeries: async (id) => {
        const res = await axios.get(`/season/series/${id}`); //seriesId
        return res;
    },

    tvdbGetSeasonsBySeries: async (id) => {
        const res = await axios.get(`/api/season/series/${id}`); //tvdbId
        return res;
    },


}));

export default seasonStore;